import React from 'react';
import { connect } from 'react-redux';
import KuposHelmet from '../../../common/KuposHelmet';

const ThemeSevenPriceAndServicesScreen = props => {
  return props.home.operator ? (
    <div className="themes-theme-seven-price-and-services-screen">
      <KuposHelmet />
      <div id="prices_services">
        <div class="new-container">
          <div class="heading">
            <h1>Precios y servicios</h1>
          </div>
        </div>
      </div>

      <div className="new-container">
        <div className="col-md-12">
          <div className="prices_services">
            <h3>
              <span>Precios y servicios</span>
            </h3>
            <div className="price-details">
              <img
                src="/assets/fernandez/services/Horarios-imagen.png"
                alt="schedules"
                width="100%"
              />
              <br /> <br /> <br />
              <img
                src="/assets/fernandez/services/BusesFernandez-Images-PricesAndServices-Schedules-new-1.png"
                alt="schedules"
                width="100%"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeSevenPriceAndServicesScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeSeven/ThemeSevenPages/ThemeSevenPriceAndServicesScreen.js